module.exports = {
	main: {
		site_id: 1138,
		title: "BetOne",
		hotjarId: 2408642,
		hotjarSv: 6,
		source: 99,
		subscribeToCashdesk: true,
		staffPassword: "995511",
		websitePasswordHash: "4b90fe42fa002772ace2a046b86b00f00f34e96bec28c1e8abcb3b561eecba47",
		timeFormat: "HH:mm",
		//"upperScreenDefaultIframe": "https://lasvegas-games.ro/bettv/",
		prematchDayFilterValue: [-1, 1, 2, 3, 999],
		availableLanguages: {
			eng: {
				short: "EN",
				full: "English",
				region: "UnitedKingdom",
				order: 1,
			},
			rum: {
				short: "RO",
				full: "Romaina",
				region: "Romania",
				order: 20,
			},
		},
		enableCoeficenFullValueView: false,
		roundDecimalCoefficients: 3,
		coefficientsDecimalZeroFill: false,
		disableGeoLocationLanguage: true,
		disableAddEventsFromSameGame: true,
		showSportsbookInterfaceSettings: false,
		rfidPinCode: "required",
		enableTabletVersion: true,
		enabelFromGameToMarkets: true,
		enableRuntimePopup: false,
		disableBetSlipSingleTypeMoreTwo: true,
		enableLinkInBetslip: true,
		disableKeyboardBarcodeCatch: false,
		video: {
			availableVideoProviderIds: [1, 3, 5, 16, 19],
		},
		googleAnalyticsId: "UA-152567467-2",
		taxRange: [
			{ range: [0, 66750], present: 1 },
			{ range: [66750, 445000], present: 16 },
			{ range: [445000, 100000000000000], present: 25 },
		],
	},
	counterOfferTimer: 15,
	taxPercentOnStake: 5,
	enableDepositMoney: true,
	rfid: {
		logoutIfIdleSecondsCount: 60,
	},
	swarm: {
		debugging: false, //enable websocket debugging
		languageMap: {
			pol: "eng",
			por: "por_2",
			"pt-br": "por",
			fre: "fra",
			chi: "zho",
			mac: "mkd",
			bgr: "bul",
			lat: "lav",
			fas: "far",
			rum: "ron",
		},
		sendSourceInRequestSession: true,
		sendTerminalIdlInRequestSession: false,
		webSocketTimeout: 5000,
		url: [
			{
				url: "https://eu-swarm-betshops-lp.betconstruct.com",
			},
		],
		websocket: [
			{
				// "url": "wss://swarm-staging.betconstruct.com"//staging swarm url
				url: "wss://mrg-swarm-betshops-ws.betconstruct.com/",
			},
		],
		useWebSocket: true,
		maxWebsocketRetries: 100, // maximum number of websocket reconnect attempts after which it will give up
		webSocketRetryInterval: 2000, // retry interval, in milliseconds (will be increased after each unsuccessful retry by itself)
	},
	virtualGames: {
		enabled: true,
		videoInUpperscreen: true,
		providers: {
			Betconstruct: {
				name: "Betconstruct",
				id: 15,
			},
			// "Inspired": {
			//     "name": "Inspired",
			//     "id": 29
			// },
			//  'Golden Race': {
			//      "id": "400002",
			//      "name": 'Golden Race',
			//      "type": 'iframe',
			//  }
		},
	},
	liveCasino: {
		games: {
			loaderStep: 21,
		},
	},
	env: {
		lang: "rum",
		oddsFormat: "decimal",
	},
	betBuilder: {
		url: "https://betconstruct-prod-gen2.sportcastlive.com/markets",
		licenseKey: "a6aa080b-cea9-4e3f-aa02-9fef8d1f0c8f",
		brand: "betone",
		password: "ewmFb896vwmHeRFp",
		oddsMap: {
			decimal: "DecimalPrice",
			american: "AmericanPrice",
			fractional: "FractionalPrice",
			hongkong: "HongKongPrice",
			indo: "IndoPrice",
			malay: "MalayPrice",
		},
		languageMap: {
			eng: "en-GB",
			spa: "es-ES",
			arm: "hy-AM",
			rus: "ru-RU",
			por: "pt-PT",
			tur: "tr-TR",
		},
	},
	ticketIn: { enabled: false },
	betting: {
		enableChainBet: false,
		enableExpressBonus: true,
		enableSuperBet: true,
		enableBetBuilder: true,
		enableBetBuilderSection: true,
		enableSuperBetAutomatically: true,
		enableCounterOffer: false,
		allowSuperBetForLive: true,
		showTotalWinWithoutBonus: true,
		maxPossibleWin: 150000,
		totalOddsMax: 99999999,
		boostedMinCountInBetslip: 0,
	},
	rulesURL: "https://newbettingterminal-bet-one.betconstruct.com.com/rulesContent/Regulament-pariuri.pdf",
	termsAndConditionsDefaultLanguage: "eng",
	terminal: {
		showMinPossibleWin: true,
		asianViewEnabled: true,
		scrollButtons: false,
		scrollButtonsSearchAndPrintLotteryTickets: true,
		scrollButtonsSearchAndPrintTickets: true,
		signInToAdmin: true,

		setGameListDropDown: false,
		printUserBet: true,
		disableLiveGamesInToday: true,
		enableSignOutWithRfidButton: true,
		asianViewTwoImportantMarkets: true,
		disableTicket: true,
		featuredGames: 6,
		enableAgeRestriction: true,
	},
	enableDraggable: true,
	setDefaultBetSlipSettingType: true,
	betslipInHomePage: true,
	financialButtons: ["Last entered bills and coins", "Stacker Balance", "Todays Report", "Encashment"],
	applicationAndTerminalButtons: [
		{
			name: "Shut down terminal",
			hideOnRestrictMode: true,
		},
		{
			name: "Close application",
			hideOnRestrictMode: true,
		},
		{
			name: "Reboot PC",
			hideOnRestrictMode: false,
		},
	],
	lotteryTicketsCountOnRestrictedMode: 5,
	lastTicketButtons: [
		{
			name: "Search and print Lottery tickets",
			type: "printLastTicketCasino",
			hideOnRestrictMode: false,
		},
		{
			name: "Show last tickets",
			type: "printLastTicket",
		},
		{
			name: "Print last cash out ticket",
			type: "printLastCashoutTicket",
			hideOnRestrictMode: false,
		},
		{
			name: "Print last bet ticket",
			type: "printLastBetTicket",
			hideOnRestrictMode: true,
		},
		{
			name: "Reprint cashout tickets",
			type: "reprintCashoutTickets",
			hideOnRestrictMode: false,
		},
	],
	openSectionNameOnClick: false,
	colorForTimer: "#cbe100",
	showPopupAfterActions: true,
	regionShortNames: {
		Europe: "EUROPA",
		Romania: "RO",
		Germany: "GER",
		Spain: "SPA",
		England: "ANG",
		"Czech Republic": "CEH",
		Denmark: "DAN",
		USA: "SUA",
		Netherlands: "OLA",
		Portugal: "POR",
		Croatia: "CRO",
		Switzerland: "ELV",
		Algeria: "ALG",
		Sweden: "SUE",
		World: "INT",
		"North America": "SUA",
	},
	headerItems: [
		{
			url: "live",
			name: "Live",
			enabled: true,
		},
		{
			url: "prematch",
			name: "Prematch",
			enabled: true,
		},
		{
			url: "today",
			name: "Today",
			enabled: false,
		},
		{
			url: "casino",
			name: "Casino",
			enabled: false,
		},
		{
			url: "dealer",
			name: "Live Casino",
			enabled: false,
		},
		{
			url: "virtualGames",
			name: "Virtuals",
			enabled: true,
		},
		{
			url: "thirdPartyGame/112001",
			name: "Loto",
			enabled: true,
			iframeFullscreen: false,
			gameId: "112001",
			gameWithSecondScreen: false,
		},
		{
			url: "thirdPartyGame/112003",
			name: "Lucky Wheel",
			enabled: false,
			iframeFullscreen: false,
			gameId: "112003",
			gameWithSecondScreen: false,
		},
		{
			url: "thirdPartyGame/112005",
			name: "Rocket Jet",
			enabled: true,
			iframeFullscreen: false,
			gameId: "400002",
			onlyInHeader: true,
			gameWithSecondScreen: false,
		},
		{
			url: "thirdPartyGame/112002",
			name: "Book of 6",
			enabled: true,
			iframeFullscreen: false,
			gameId: "112002",
			gameWithSecondScreen: false,
		},
		{
			url: "thirdPartyGame/400002",
			name: "Golden Race",
			enabled: false,
			iframeFullscreen: false,
			gameId: "400002",
			gameWithSecondScreen: false,
			onlyInHeader: true,
		},
		// {
		//     "url": "tournaments",
		//     "name": "Tournaments",
		//     "onlyInHeader": true,
		//     "enabled": true
		// },
		{
			url: "thirdPartyGame/112004 ",
			name: "Bile",
			enabled: false,
			iframeFullscreen: false,
			gameId: "112004",
			gameWithSecondScreen: false,
		},
		{
			url: "result",
			name: "Result",
			enabled: true,
		},
		{
			url: "realHorseRacing",
			name: "Horse Racing",
			enabled: false,
		},
		{
			url: "thirdPartyGame/400031666",
			name: "Lucky 6",
			iframeFullscreen: false,
			gameId: "400031666",
			gameWithSecondScreen: true,
			limitgroupId: 1,
			tableId: 2101,
			enabled: false,
		},
		{
			url: "thirdPartyGame/42078",
			name: "Lottery",
			enabled: false,
			iframeFullscreen: false,
			gameId: "42078",
			gameWithSecondScreen: false,
		},
	],
	enableRefreshButton: true,
	adminWideLotteryPopups: true,
	hasPrintPayout: true,
	adminPageButtons: [
		{
			name: "Admin User",
			type: "adminUserSections",
			hideOnRestrictMode: true,
			enabled: true,
		},
		{
			name: "Application and terminal management",
			type: "applicationAndTerminal",
			enabled: true,
		},
		{
			name: "Tickets",
			type: "lastTicket",
			enabled: true,
		},
		{
			name: "Financial tracking",
			type: "financialTracking",
			hideOnRestrictMode: false,
			enabled: true,
		},
		{
			name: "Open last log file",
			type: "openLastLogFile",
			enabled: true,
			hideOnRestrictMode: true,
		},
		{
			name: "Lock",
			type: "lockAndUnlock",
			param: { type: "lock" },
			hideOnRestrictMode: true,
			enabled: true,
		},
		{
			name: "Unlock",
			type: "lockAndUnlock",
			param: { type: "unlock" },
			hideOnRestrictMode: true,
			enabled: true,
		},
		{
			name: "Devices",
			type: "devices",
			enabled: true,
			hideOnRestrictMode: true,
		},
	],
	restrictedAdminPrintableTicketsCount: 5,
	searchInHeader: true,
	showGameNumber: true,
	setOnlyBetcoGames: true,
	enableDmsValidationField: true,
	popupForTerminalInactivity: true,
	enableLogoOnPopups: false,
	ticketCheckBetSlip: true,
	favoriteCompetitionsScroll: false,
	enableHomeImageSlider: false,
	enableSliderForBetone: true,
	homePageView: 4,
	enableBaseDropDown: false,
	marketsNofitication: [
		"YellowCardWillbeBeforeaCorner",
		"YellowCardsOverUnder",
		"Team1YellowCardsOverUnder",
		"Team2YellowCardsOverUnder",
		"HalfTimeYellowCardTotal",
		"YellowCards2ndHalfTotal",
		"YellowCards:1stHalfTeam1Total",
		"YellowCards1stHalfTeam2Total",
		"MatchYellowCardLastTeam",
		"YellowCards:2ndHalfTeam1Total",
		"YellowCards:2ndHalfTeam2Total",
		"HalfWithTheMostYellowCards",
		"MatchVarTotalOverUnder",
		"VARDuringtheMatch",
		"On-FieldReview(VAR)DuringtheMatch",
		"Confirmed/CountGoalAfterVAR",
		"Unconfirmed/Doesn'tCountGoalAfterVAR",
		"Confirmed/GivenPenaltyAfterVAR",
		"Unconfirmed/Wasn'tGivenPenaltyAfterVAR",
	],
	refreshButtonDisabledTime: 5000,
	estimatedReturnAndTotalWinCalculationChange: true,
	enableCurrencyView: false,
	homePageCompetitionsCount: 4,
	turnOffMaxBetButton: true,
	enableTopGames: false,
	maxGameLoadCountToSelectRegion: 120,
	homePageHorseRacing: false,
	enableLiveClock: true,
	enableMarketSearch: true,
	swapTaxAndBonus: true,
	enableMultiplesForPrematch: true,
	enablePredefinedMultiples: true,
	sportListThatCanBeBoostedOdds: [
		"Soccer",
		"Tennis",
		"Basketball",
		"Handball",
		"IceHockey",
		"Snooker",
		"Volleyball",
		"Baseball",
		"Boxing",
		"Mma",
		"Darts",
		"AmericanFootball",
		"Futsal",
		"RugbyUnion",
		"Politics",
		"Formula1",
		"Motorbikes",
	],
	superBetCountdownTime: 150,
	virtualsEnablePopup: true,
	enableBoostedOdds: true,
	defaultTerminalParams: { pid: 1138, tid: 13601, token: "0IDcBQ==", currency: "RON" },
	//"defaultTerminalParams": { pid: 33, tid: 992, token: "bnBzAA==", currency: 'EUR' },
	staticStake: true,
	enableUpcomingLiveGamesInPrematch: true,
	staticStakeCounts: { default: [5, 10, 20, 50, 100] },
	enableFeaturedGamesInHome5: false,
	enableCopyBetButton: true,
	dmsTicketInEnable: true,
	enableMultipleWinsPopup: true,
	enableDayFormatInPrematchLeftMenu: true,
	useCurrencySymbol: false,
	enableTodayButtonOnSport: true,
	enableMarketCountInBetSlip: true,
	enableTouchPositionIniFrames: true,
	enableOrderInBetslip: true,
	AdminShortcutWithLoginOnly: false,
	asianViewMarket: {
		Soccer: {
			live: [
				[
					{
						display_key: "WINNER",
						title: "WINNER",
						side: ["P1", "X", "P2"],
					},
					{
						display_key: "DOUBLE CHANCE",
						title: "DOUBLE CHANCE",
						side: ["1X", "12", "X2"],
					},
					{
						display_key: "NEXTGOALTOSCORE",
						title: "NEXT GOAL TO SCORE",
						side: ["Home", "No", "Away"],
					},
				],
				[
					{
						display_key: "TOTALS",
						market_type: {
							"@in": [
								"OverUnder",
								"HalfTimeOverUnder",
								"2ndHalfTotalOver/Under",
							],
						},
						title: "Total Goals 2.5",
						side: ["Over", "Under"],
						base: 2.5,
					},
					{
						display_key: "BOTHTEAMTOSCORE",
						title: "Both Team To Score",
						side: ["Yes", "No"],
					},
					{
						display_key: "DRAWNOBET",
						title: "Draw No Bet",
						side: ["Team1", "Team2"],
					},
					{
						display_key: "TOTALS",
						market_type: {
							"@in": [
								"OverUnder",
								"HalfTimeOverUnder",
								"2ndHalfTotalOver/Under",
							],
						},
						title: "Total Goals 1.5",
						side: ["Over", "Under"],
						base: 1.5,
					},
					{
						display_key: "TOTALS",
						market_type: {
							"@in": [
								"OverUnder",
								"HalfTimeOverUnder",
								"2ndHalfTotalOver/Under",
							],
						},
						title: "Total Goals 3.5",
						side: ["Over", "Under"],
						base: 3.5,
					},
					// {
					//     "display_key": "TOTALS",
					//     "market_type": { "@in": ["OverUnderAsian", "HalfTimeOverUnderAsian", "2ndHalfTotalOver/UnderAsian"] },
					//     "title": "Total Goals Asian",
					//     "side": ["Over", "Under"]
					// },
					{
						display_key: "ODD/EVEN",
						market_type: {
							"@in": [
								"EvenOddTotal",
								"FirstHalfEvenOddTotal",
								"SecondHalfEvenOddTotal",
							],
						},

						title: "Total Goals: Even/Odd",
						side: ["Even", "Odd"],
					},
					{
						display_key: "HANDICAP",
						market_type: {
							"@in": [
								"AsianHandicap",
								"HalfTimeAsianHandicap",
								"2ndHalfAsianHandicap",
							],
						},
						title: "Handicap",
						side: ["Home", "Away"],
						main_order: { "@in": [1, 2, 3, 4] },
					},
					// {
					//     "display_key": "HANDICAP",
					//     "market_type": { "@in": ["AsianHandicapAsian", "HalfTimeAsianHandicapAsian", "2ndHalfAsianHandicapAsian"] },
					//     "title": "Asian Handicap",
					//     "side": ["Home", "Away"],
					//     "main_order": { "@in": [1, 2] }
					// },
					{
						display_key: "CARDSTOTALS",
						title: "Yellow Cards: Total",
						side: ["Over", "Under"],
					},
				],
			],
			prematch: [
				[
					{
						display_key: "WINNER",
						title: "WINNER",
						side: ["P1", "X", "P2"],
					},
					{
						display_key: "DOUBLE CHANCE",
						title: "DOUBLE CHANCE",
						side: ["1X", "12", "X2"],
					},
				],
				[
					{
						display_key: "TOTALS",
						market_type: {
							"@in": [
								"OverUnder",
								"HalfTimeOverUnder",
								"2ndHalfTotalOver/Under",
							],
						},
						title: "Total Goals 2.5",
						side: ["Over", "Under"],
						base: 2.5,
					},
					{
						display_key: "BOTHTEAMTOSCORE",
						title: "Both Team To Score",
						side: ["Yes", "No"],
					},
					{
						display_key: "DRAWNOBET",
						title: "Draw No Bet",
						side: ["Team1", "Team2"],
					},
					{
						display_key: "TOTALS",
						market_type: {
							"@in": [
								"OverUnder",
								"HalfTimeOverUnder",
								"2ndHalfTotalOver/Under",
							],
						},
						title: "Total Goals 1.5",
						side: ["Over", "Under"],
						base: 1.5,
					},
					{
						display_key: "TOTALS",
						market_type: {
							"@in": [
								"OverUnder",
								"HalfTimeOverUnder",
								"2ndHalfTotalOver/Under",
							],
						},
						title: "Total Goals 3.5",
						side: ["Over", "Under"],
						base: 3.5,
					},
					// {
					//     "display_key": "TOTALS",
					//     "market_type": { "@in": ["OverUnderAsian", "HalfTimeOverUnderAsian", "2ndHalfTotalOver/UnderAsian"] },
					//     "title": "Total Goals Asian",
					//     "side": ["Over", "Under"]
					// },
					// {
					//     "display_key": "ODD/EVEN",
					//     "market_type": { "@in": ["EvenOddTotal", "FirstHalfEvenOddTotal", "SecondHalfEvenOddTotal"] },
					//     "title": "Total Goals: Even/Odd",
					//     "side": ["Even", "Odd"]
					// },
					{
						display_key: "HANDICAP",
						market_type: {
							"@in": [
								"AsianHandicap",
								"HalfTimeAsianHandicap",
								"2ndHalfAsianHandicap",
							],
						},
						title: "Handicap",
						side: ["Home", "Away"],
						main_order: { "@in": [1, 2, 3, 4] },
						//"base": { "@in": [0.5, 1.5, 2.5, 3.5] }   //todo: check why not working like this
					},
					// {
					//     "display_key": "HANDICAP",
					//     "market_type": { "@in": ["AsianHandicapAsian", "HalfTimeAsianHandicapAsian", "2ndHalfAsianHandicapAsian"] },
					//     "title": "Asian Handicap",
					//     "side": ["Home", "Away"],
					//     "main_order": { "@in": [1, 2] }
					// },
					{
						display_key: "CARDSTOTALS",
						title: "Yellow Cards: Total",
						side: ["Over", "Under"],
					},
				],
			],
		},
		IceHockey: {
			live: [
				[
					{
						display_key: "WINNER",
						title: "Winner (With Overtime)",
						market_type: "MatchWinner2",
						side: ["P1", "P2"],
					},
					{
						display_key: "WINNER",
						title: "Winner (Regular Time)",
						col_count: 3,
						side: ["P1", "X", "P2"],
					},
					//{
					//    "display_key": "DOUBLE CHANCE",
					//    "title": "Double chance (Regular Time)",
					//    "side": ["1X", "12", "X2"]
					//},

					//{
					//    "market_type": "NextTeamToScore",       //todo: check this market when games are live
					//    "title": "Next Team to Score",
					//    "side": ["Home", "Away", "No"]
					//}
				],
				[
					{
						market_type: { "@in": ["MatchTotal2", "PeriodTotal2"] },
						display_key: "TOTALS",
						base: 5.5,
						title: "Total Goals 5.5(Regular Time)",
						side: ["Over", "Under"],
					},
					{
						market_type: { "@in": ["MatchTotal3", "PeriodTotal3"] }, // there is no PeriodTotal3, leave for the future
						display_key: "TOTALS",
						title: "Total 3 Way (Regular Time)",
						side: ["Over", "Exactly", "Under"],
					},
					{
						market_type: { "@in": ["MatchTotal2Asian", "PeriodTotal2Asian"] },
						display_key: "TOTALS",
						title: "Asian Total (Regular Time)",
						side: ["Over", "Under"],
					},
					//{
					//    "display_key": "BOTHTEAMTOSCORE",
					//    "title": "Both Team To Score",
					//    "side": ["Yes", "No"]
					//},
					{
						market_type: { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
						display_key: "HANDICAP",
						title: "Handicap (Regular Time)",
						side: ["Home", "Away"],
					},
					// {
					//     "market_type": { "@in": ["MatchHandicap2Asian", "PeriodHandicap2Asian"] },
					//     "display_key": "HANDICAP",
					//     "title": "Asian Handicap (Regular Time)",
					//     "side": ["Home", "Away"]
					// }
					//odd even apush market Khcoi asac chenq drel
				],
			],
			prematch: [
				[
					{
						display_key: "WINNER",
						title: "Winner (With Overtime)",
						market_type: "MatchWinner2",
						side: ["P1", "P2"],
					},
					{
						display_key: "WINNER",
						title: "Winner (Regular Time)",
						col_count: 3,
						side: ["P1", "X", "P2"],
					},
					//{
					//    "display_key": "DOUBLE CHANCE",
					//    "title": "Double chance (Regular Time)",
					//    "side": ["1X", "12", "X2"]
					//},

					//{
					//    "market_type": "NextTeamToScore",       //todo: check this market when games are live
					//    "title": "Next Team to Score",
					//    "side": ["Home", "Away", "No"]
					//}
				],
				[
					{
						market_type: { "@in": ["MatchTotal2", "PeriodTotal2"] },
						display_key: "TOTALS",
						title: "Total Goals 5.5(Regular Time)",
						side: ["Over", "Under"],
						base: 5.5,
					},
					{
						market_type: { "@in": ["MatchTotal3", "PeriodTotal3"] }, // there is no PeriodTotal3, leave for the future
						display_key: "TOTALS",
						title: "Total 3 Way (Regular Time)",
						side: ["Over", "Exactly", "Under"],
					},
					{
						market_type: { "@in": ["MatchTotal2Asian", "PeriodTotal2Asian"] },
						display_key: "TOTALS",
						title: "Asian Total (Regular Time)",
						side: ["Over", "Under"],
					},
					//{
					//    "display_key": "BOTHTEAMTOSCORE",
					//    "title": "Both Team To Score",
					//    "side": ["Yes", "No"]
					//},
					{
						market_type: { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
						display_key: "HANDICAP",
						title: "Handicap (Regular Time)",
						side: ["Home", "Away"],
					},
					// {
					//     "market_type": { "@in": ["MatchHandicap2Asian", "PeriodHandicap2Asian"] },
					//     "display_key": "HANDICAP",
					//     "title": "Asian Handicap (Regular Time)",
					//     "side": ["Home", "Away"]
					// }
					//odd even apush market Khcoi asac chenq drel
				],
			],
		},
		BeachFootball: {
			live: [
				[
					{
						display_key: "WINNER",
						title: "Match Result",
						col_count: 3,
						side: ["P1", "X", "P2"],
					},
				],
				[
					{
						display_key: "TOTALS",
						market_type: { "@in": ["Over/Under"] },
						title: "TOTALS",
						side: ["Over", "Under"],
					},
				],
			],
			prematch: [
				[
					{
						display_key: "WINNER",
						title: "Match Result",
						col_count: 3,
						side: ["P1", "X", "P2"],
					},
				],
				[
					{
						display_key: "TOTALS",
						market_type: { "@in": ["Over/Under"] },
						title: "TOTALS",
						side: ["Over", "Under"],
					},
				],
			],
		},
		Hockey: {
			live: [
				[
					{
						display_key: "WINNER",
						title: "Winner (With Overtime)",
						market_type: "MatchWinner2",
						side: ["P1", "P2"],
					},
					{
						display_key: "WINNER",
						title: "Winner (Regular Time)",
						col_count: 3,
						side: ["P1", "X", "P2"],
					},
					//{
					//    "display_key": "DOUBLE CHANCE",
					//    "title": "Double chance (Regular Time)",
					//    "side": ["1X", "12", "X2"]
					//},

					//{
					//    "market_type": "NextTeamToScore",       //todo: check this market when games are live
					//    "title": "Next Team to Score",
					//    "side": ["Home", "Away", "No"]
					//}
				],
				[
					{
						market_type: { "@in": ["MatchTotal2", "PeriodTotal2"] },
						display_key: "TOTALS",
						base: 5.5,
						title: "Total Goals 5.5(Regular Time)",
						side: ["Over", "Under"],
					},
					{
						market_type: { "@in": ["MatchTotal3", "PeriodTotal3"] }, // there is no PeriodTotal3, leave for the future
						display_key: "TOTALS",
						title: "Total 3 Way (Regular Time)",
						side: ["Over", "Exactly", "Under"],
					},
					{
						market_type: { "@in": ["MatchTotal2Asian", "PeriodTotal2Asian"] },
						display_key: "TOTALS",
						title: "Asian Total (Regular Time)",
						side: ["Over", "Under"],
					},
					//{
					//    "display_key": "BOTHTEAMTOSCORE",
					//    "title": "Both Team To Score",
					//    "side": ["Yes", "No"]
					//},
					{
						market_type: { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
						display_key: "HANDICAP",
						title: "Handicap (Regular Time)",
						side: ["Home", "Away"],
					},
					// {
					//     "market_type": { "@in": ["MatchHandicap2Asian", "PeriodHandicap2Asian"] },
					//     "display_key": "HANDICAP",
					//     "title": "Asian Handicap (Regular Time)",
					//     "side": ["Home", "Away"]
					// }
					//odd even apush market Khcoi asac chenq drel
				],
			],
			prematch: [
				[
					{
						display_key: "WINNER",
						title: "Match Result",
						market_type: "MatchResult",
						side: ["P1", "X", "P2"],
					},
					//{
					//    "display_key": "DOUBLE CHANCE",
					//    "title": "Double chance (Regular Time)",
					//    "side": ["1X", "12", "X2"]
					//},

					//{
					//    "market_type": "NextTeamToScore",       //todo: check this market when games are live
					//    "title": "Next Team to Score",
					//    "side": ["Home", "Away", "No"]
					//}
				],
				[
					{
						market_type: { "@in": ["MatchTotal2", "PeriodTotal2"] },
						display_key: "TOTALS",
						title: "Total Goals 5.5(Regular Time)",
						side: ["Over", "Under"],
						base: 5.5,
					},
					{
						market_type: { "@in": ["MatchTotal3", "PeriodTotal3"] }, // there is no PeriodTotal3, leave for the future
						display_key: "TOTALS",
						title: "Total 3 Way (Regular Time)",
						side: ["Over", "Exactly", "Under"],
					},
					{
						market_type: { "@in": ["MatchTotal2Asian", "PeriodTotal2Asian"] },
						display_key: "TOTALS",
						title: "Asian Total (Regular Time)",
						side: ["Over", "Under"],
					},
					//{
					//    "display_key": "BOTHTEAMTOSCORE",
					//    "title": "Both Team To Score",
					//    "side": ["Yes", "No"]
					//},
					{
						market_type: { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
						display_key: "HANDICAP",
						title: "Handicap (Regular Time)",
						side: ["Home", "Away"],
					},
					// {
					//     "market_type": { "@in": ["MatchHandicap2Asian", "PeriodHandicap2Asian"] },
					//     "display_key": "HANDICAP",
					//     "title": "Asian Handicap (Regular Time)",
					//     "side": ["Home", "Away"]
					// }
					//odd even apush market Khcoi asac chenq drel
				],
			],
		},
		Floorball: {
			live: [
				[
					{
						display_key: "WINNER",
						title: "Match Result",
						col_count: 3,
						side: ["P1", "X", "P2"],
					},
				],
				[
					{
						display_key: "TOTALS",
						market_type: { "@in": ["Over/Under"] },
						title: "TOTALS",
						side: ["Over", "Under"],
					},
				],
			],
			prematch: [
				[
					{
						display_key: "WINNER",
						title: "Match Result",
						col_count: 3,
						side: ["P1", "X", "P2"],
					},
				],
				[
					{
						display_key: "TOTALS",
						market_type: { "@in": ["Over/Under"] },
						title: "TOTALS",
						side: ["Over", "Under"],
					},
				],
			],
		},
		Basketball: {
			live: [
				[
					{
						display_key: "WINNER",
						title: "Winner 2 Way",
						col_count: 2,
						side: ["P1", "P2"],
					},
				],
				[
					// {
					//    "title": "Overtime",
					//    "market_type": "Overtime",
					//     "side": ["P1", "P2"]
					// }, {
					//     "display_key": "HANDICAP",
					//     "title": "Match Handicap",
					//    "side": ["Home", "Away"]
					// },
					{
						display_key: "TOTALS",
						title: "Total Points",
						side: ["Over", "Under"],
					},
					//{
					//  "display_key": "ODD/EVEN",
					//  "title": "Match Total Odd/Even",
					//  "side": ["Even", "Odd"]
					//}
				],
			],
			prematch: [
				[
					{
						display_key: "WINNER",
						title: "Winner 2 Way",
						col_count: 2,
						side: ["P1", "P2"],
					},
				],
				[
					//{
					//     "title": "Overtime",
					//     "market_type": "Overtime",
					//     "side": ["P1", "P2"]
					//}, {
					//      "display_key": "HANDICAP",
					//     "title": "Match Handicap",
					//     "side": ["Home", "Away"]
					// },
					{
						display_key: "TOTALS",
						title: "Total Points",
						side: ["Over", "Under"],
					},
					// {
					//    "display_key": "ODD/EVEN",
					//    "title": "Match Total Odd/Even",
					//   "side": ["Even", "Odd"]
					//  }
				],
			],
		},
		CyberFootball: {
			live: [
				[
					{
						display_key: "WINNER",
						title: "Match Result",
						col_count: 3,
						side: ["P1", "X", "P2"],
					},
				],
				[
					{
						display_key: "TOTALS",
						title: "TOTALS",
						side: ["Over", "Under"],
					},
				],
			],
			prematch: [
				[
					{
						display_key: "WINNER",
						title: "Match Result",
						col_count: 3,
						side: ["P1", "X", "P2"],
					},
				],
				[
					{
						display_key: "TOTALS",
						title: "TOTALS",
						side: ["Over", "Under"],
					},
				],
			],
		},
		Volleyball: {
			live: [
				[
					{
						display_key: "WINNER",
						title: "Winner",
						side: ["P1", "P2"],
					},
					//  {
					//      "market_type": "HANDICAP", //todo: check this market when games are live
					//      "title": "Match points Handicap",
					//      "side": ["Home", "Away"]
					// }
					//  ], [

					// {
					//     "market_type": { "@in": ["MatchTotal2Asian", "PeriodTotal2Asian"] },
					//     "display_key": "TOTALS",
					//     "title": "Asian Total (Regular Time)",
					//     "side": ["Over", "Under"]
					// },
					{
						display_key: "TOTALS",
						market_type: {
							"@in": ["MatchTotalPointsOverUnder", "SetTotalOverUnder"],
						}, //todo: check this market when games are live
						title: "Total points",
						side: ["Over", "Under"],
					},
					{
						market_type: { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
						display_key: "HANDICAP",
						title: "Handicap (Regular Time)",
						side: ["Home", "Away"],
					},
				],
				[
					{
						display_key: "TOTALS",
						market_type: {
							"@in": ["MatchTotalPointsOverUnder", "SetTotalOverUnder"],
						}, //todo: check this market when games are live
						title: "Total points",
						side: ["Over", "Under"],
					},
				],
			],
			prematch: [
				[
					{
						display_key: "WINNER",
						title: "Winner",
						side: ["P1", "P2"],
					},
					{
						market_type: "HANDICAP", //todo: check this market when games are live
						title: "Match points Handicap",
						side: ["Home", "Away"],
					},
				],
				[
					// {
					//     "market_type": { "@in": ["MatchTotal2Asian", "PeriodTotal2Asian"] },
					//     "display_key": "TOTALS",
					//     "title": "Asian Total (Regular Time)",
					//     "side": ["Over", "Under"]
					// },
					{
						display_key: "TOTALS",
						market_type: {
							"@in": ["MatchTotalPointsOverUnder", "SetTotalOverUnder"],
						}, //todo: check this market when games are live
						title: "Total points",
						side: ["Over", "Under"],
					},
					{
						market_type: { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
						display_key: "HANDICAP",
						title: "Handicap (Regular Time)",
						side: ["Home", "Away"],
					},
				],
			],
		},
	},
};
